import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

type Tone = 'danger' | 'primary' | 'success';

const COLOR: Record<Tone, string> = {
  danger: 'bg-ops-danger',
  primary: 'bg-ops-primary',
  success: 'bg-ops-success',
};

export function NotificationDot({
  children,
  show = true,
  count,
  tone = 'danger',
  className,
}: {
  children?: ReactNode;
  show?: boolean;
  count?: number;
  tone?: Tone;
  className?: string;
}) {
  // Самостоятельная точка (без обёртки вокруг элемента).
  if (!children) {
    return show ? <span className={cn('inline-block h-2 w-2 rounded-full', COLOR[tone], className)} /> : null;
  }

  return (
    <span className={cn('relative inline-flex', className)}>
      {children}
      {show &&
        (typeof count === 'number' ? (
          <span
            className={cn(
              'absolute -right-1.5 -top-1.5 inline-flex h-4 min-w-4 items-center justify-center rounded-ops-pill px-1',
              'text-ops-micro font-bold text-white ring-2 ring-ops-surface',
              COLOR[tone],
            )}
          >
            {count > 99 ? '99+' : count}
          </span>
        ) : (
          <span className={cn('absolute -right-0.5 -top-0.5 h-2.5 w-2.5 rounded-full ring-2 ring-ops-surface', COLOR[tone])} />
        ))}
    </span>
  );
}
